import { useForm } from '@tanstack/react-form';
import type { FormFooterProps, FormProps } from '@/types/form/form-props';
import { cn } from '@/lib/utils';
import { RequestOtpInput, RequestOtpInputSchema } from '../api/request-otp';
import { TextInput } from '@/shared/components/ui/inputs/text-input';
import { fieldToInputProps, toFormProps } from '@/utils/shared/form';
import { Link, useLocation } from 'react-router-dom';
import { LoadingButton } from '@/shared/components/ui/buttons/loading-button';
import { Button } from '@/shared/components/ui/button';
import { paths } from '@/config/paths';
import { Send } from 'lucide-react';

export function RequestOtpForm({ onSubmit, className, Footer = RequestOtpFormFooter }: FormProps<RequestOtpInput>) {
  const form = useForm({
    defaultValues: { email: '' },
    validators: { onSubmit: RequestOtpInputSchema },
    onSubmit: ({ value }) => onSubmit(value),
  });

  return (
    <form {...toFormProps(form)} className={cn('space-y-4', className)}>
      <form.Field name="email">{(field) => <TextInput {...fieldToInputProps(field, 'E-post')} />}</form.Field>

      <form.Subscribe selector={(state) => [state.canSubmit, state.isSubmitting]}>
        {([canSubmit, isSubmitting]) => (
          <Footer canSubmit={canSubmit} isSubmitting={isSubmitting} submitText="Skicka kod" resetText="" />
        )}
      </form.Subscribe>
    </form>
  );
}

export function RequestOtpFormFooter({ canSubmit, isSubmitting, submitText = 'Skicka' }: FormFooterProps) {
  const { search } = useLocation();

  return (
    <div className="flex gap-2 justify-between">
      <Button asChild variant={'ghost'}>
        <Link to={paths.auth.register.getHref(new URLSearchParams(search).get('redirect'))}>Ny användare?</Link>
      </Button>
      <LoadingButton disabled={!canSubmit} isLoading={isSubmitting} type="submit">
        <Send />
        {submitText}
      </LoadingButton>
    </div>
  );
}
